import {
  VButton,
  VDropdownMenu,
  VDropdownMenuContent,
  VDropdownMenuItem,
  VDropdownMenuTrigger,
  cn,
} from '@vrzl/ui';
import { Check, ChevronDown } from 'lucide-react';

import { statusOrderOptions, statusOrderTriggerLabel, type StatusOrder } from '../lib/statusOrder';

interface StatusOrderFilterProps {
  value: StatusOrder;
  onChange: (value: StatusOrder) => void;
}

/**
 * Dropdown om de statusvolgorde van het evenementenoverzicht om te draaien.
 * Puur visueel — emit de selectie via `onChange`; de pagina beheert de URL-state en de query.
 */
export function StatusOrderFilter({ value, onChange }: StatusOrderFilterProps) {
  return (
    <VDropdownMenu>
      <VDropdownMenuTrigger asChild>
        <VButton type="button" variant="outline" size="sm" aria-label="Statusvolgorde">
          {statusOrderTriggerLabel(value)}
          <ChevronDown className="ml-1 size-4" aria-hidden />
        </VButton>
      </VDropdownMenuTrigger>
      <VDropdownMenuContent align="start">
        {statusOrderOptions.map((option) => {
          const active = option.value === value;
          return (
            <VDropdownMenuItem key={option.value} onSelect={() => onChange(option.value)}>
              <Check
                className={cn('size-4', active ? 'opacity-100' : 'opacity-0')}
                aria-hidden
              />
              {option.label}
            </VDropdownMenuItem>
          );
        })}
      </VDropdownMenuContent>
    </VDropdownMenu>
  );
}
